import { render } from "./homeArchive.vue?vue&type=template&id=e114b7e8&scoped=true"
import script from "./homeArchive.vue?vue&type=script&lang=js"
export * from "./homeArchive.vue?vue&type=script&lang=js"

import "./homeArchive.vue?vue&type=style&index=0&id=e114b7e8&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e114b7e8"]])

export default __exports__